import instance from './index.ts'

/**
 * 封装请求方式
 */
const request = {
  /**
   * @name: 封装axios get方法
   * @desc: 描述
   * @param url 请求连接
   * @param params 请求参数
   * @param config 配置参数
   */
  get(url, params, config) {
    return new Promise((resolve, reject) => {
      instance
        .get(url, {params, config})
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getAll(url, params, config) {
    return new Promise((resolve, reject) => {
      instance
        .get(url, { params: params, config })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * @name: 封装axios post方法
   * @desc: 描述
   * @param url 请求连接
   * @param params 请求参数
   * @param config 配置参数
   */
  post(url, params, config) {
    return new Promise((resolve, reject) => {
      instance
        .post(url, params, config)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * @name: put请求封装
   * @param url 请求连接
   * @param params 请求参数
   * @param config 配置参数
   */
  put(url, params, config) {
    return new Promise((resolve, reject) => {
      instance.put(url, params, config).then(
        (res) => {
          resolve(res.data)
        },
        (err) => {
          reject(err)
        }
      )
    })
  },
  /**
   * @name: put请求封装
   * @param url 请求连接
   * @param params 请求参数
   * @param config 配置参数
   */
  delete(url, params, config) {
    const dataType = (config && config.dataType) || 'params'
    let param = {}
    param[dataType] = params
    
    return new Promise((resolve, reject) => {
      instance.delete(url, Object.assign(param, config)).then(
        (res) => {
          resolve(res.data)
        },
        (err) => {
          reject(err)
        }
      )
    })
  },
  /**
   * @name: 请求失败后的错误统一处理
   * @param {Number} status 请求失败的状态码
   */
  errorHandle(status, other) {
    // 状态码判断
    switch (status) {
      // 401: 未登录状态，跳转登录页
      case 401:
        // toLogin();
        break
      // 403 token过期
      // 清除token并跳转登录页
      case 403:
        // tip('登录过期，请重新登录');
        // localStorage.removeItem('token');
        // store.commit('loginSuccess', null);
        setTimeout(() => {
          // toLogin();
        }, 1000)
        break
      // 404请求不存在
      case 404:
        // tip('请求的资源不存在');
        break
      default:
        console.log(other)
    }
  },
}
export default request
